import { createStyles } from '@/hooks';
import { colors, guardianColors } from '@/theme/colors';

export const useStyles = createStyles(({ scale }) => ({
  mobileRoot: {
    flex: 1,
  },
  // Bound ScrollView height so bounce + RefreshControl can activate (same as guardian home).
  mobileScroll: {
    flex: 1,
  },
  refreshIndicator: {
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: scale(8),
  },
  mobileBackButton: {
    position: 'absolute',
    left: scale(20),
    width: scale(40),
    height: scale(40),
    borderRadius: scale(20),
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: colors['0'],
    zIndex: 1,
  },
  mobileRightButton: {
    position: 'absolute',
    right: scale(20),
    width: scale(40),
    height: scale(40),
    borderRadius: scale(20),
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: colors['0'],
    zIndex: 1,
  },
  scrollContent: {
    paddingHorizontal: scale(20),
    gap: scale(20),
  },
  tabletRoot: {
    flex: 1,
    backgroundColor: guardianColors['1'],
  },
  tabletBody: {
    flexDirection: 'row',
    flex: 1,
  },
  tabletLeftPane: {
    width: '37%',
    borderRightWidth: 1,
    borderRightColor: guardianColors['3'],
  },
  tabletLeftPaneContent: {
    padding: scale(20),
    gap: scale(20),
  },
  tabletRightPane: {
    width: '63%',
  },
  tabletRightPaneContent: {
    padding: scale(20),
    gap: scale(12),
  },
  pressed: {
    opacity: 0.72,
  },
}));
